import { Revision } from 'types'
import { UseQueryOptions } from 'react-query'
import { useRevision } from 'hooks/queries/layers/revisions/useRevision'

interface Props {
  articleId: string
  layerId: string
  id: string
}

interface Options extends Omit<UseQueryOptions<{ revision: Revision }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollRevision = ({ articleId, layerId, id }: Props, options?: Options) => {
  return useRevision(
    { articleId, layerId, id },
    {
      refetchInterval: (data) => {
        if (data?.revision?.completed || data?.revision?.failed) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
